import { useEffect, useState } from 'react';

/**
 * Returns `value` delayed by `delayMs`. Useful for search inputs so we don't fire one request per
 * keystroke. Cancels in-flight timers when value or delay changes.
 */
export const useDebouncedValue = <T,>(value: T, delayMs = 300): T => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handle = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(handle);
  }, [value, delayMs]);

  return debounced;
};
